import { MiniMap, type Node as RFNode } from '@xyflow/react'
import { Maximize2, Minimize2 } from 'lucide-react'

const miniNodeColor = (n: RFNode) => {
  if (n.type === 'subflow') return 'rgba(120, 90, 255, 0.25)'
  if (n.type === 'sticky') return 'rgba(240, 180, 60, 0.55)'
  return 'rgba(120, 90, 255, 0.55)'
}

const miniNodeStroke = (n: RFNode) => {
  if (n.type === 'subflow') return 'rgba(120, 90, 255, 0.45)'
  if (n.type === 'sticky') return 'rgba(200, 140, 40, 0.8)'
  return 'rgba(80, 60, 200, 0.75)'
}

interface AutoHideMiniMapProps {
  visible?: boolean
  minimized?: boolean
  onToggleMinimized?: () => void
}

export default function AutoHideMiniMap({
  visible = true,
  minimized = false,
  onToggleMinimized
}: AutoHideMiniMapProps) {
  if (!visible) return null

  // If minimized, show a small button to expand in bottom-right corner (fixed position)
  if (minimized) {
    return (
      <div className="absolute bottom-3 right-3 z-[100]">
        <button
          onClick={onToggleMinimized}
          className="flex items-center justify-center w-10 h-10 bg-background/90 border border-border rounded shadow-lg hover:bg-accent hover:border-accent-foreground transition-colors"
          aria-label="Expandir mini-mapa"
          title="Expandir mini-mapa"
        >
          <Maximize2 className="h-4 w-4" />
        </button>
      </div>
    )
  }

  return (
    <div className="absolute bottom-3 right-3 z-[100]">
      <div className="relative">
        <MiniMap
          className="minimap-modern is-visible"
          style={{ width: 200, height: 140 }}
          pannable
          zoomable
          zoomStep={8}
          inversePan={false}
          offsetScale={10}
          ariaLabel="Vista general del flujo"
          bgColor="rgba(255,255,255,0.10)"
          maskColor="rgba(20,16,40,0.18)"
          maskStrokeColor="rgba(143,121,255,0.8)"
          maskStrokeWidth={2}
          nodeColor={miniNodeColor}
          nodeStrokeColor={miniNodeStroke}
          nodeBorderRadius={6}
          nodeStrokeWidth={2}
        />
        {onToggleMinimized && (
          <button
            onClick={onToggleMinimized}
            className="absolute top-1 right-1 flex items-center justify-center w-6 h-6 bg-background/80 border border-border rounded hover:bg-accent hover:border-accent-foreground transition-colors z-10"
            aria-label="Minimizar mini-mapa"
            title="Minimizar mini-mapa"
          >
            <Minimize2 className="h-3 w-3" />
          </button>
        )}
      </div>
    </div>
  )
}
